// extracted by mini-css-extract-plugin
export default {"bill":"Bill_bill__3Nv2L","billItem":"Bill_billItem__+WM00","container":"Bill_container__tKkFl"};